import { notify } from '@billy/design-system'

import { fetchBookkeepingCategories } from '../query-api'
import { BookkeepingTag } from '../types/bookkeepingTag'
import { BookkeepingTagDbValue } from '../types/bookkeepingTagDbValue'
import { BookkeepingTagNavItemValue } from '../types/bookkeepingTagNavItemValue'
import { isBookkeepingTagCategory } from './isBookkeepingTagCategory'
import { isLegacyBookkeepingTag } from './isLegacyBookkeepingTag'

interface ConvertBookkeepingTagDbValueToNavItemValueProps {
  dbValue: BookkeepingTagDbValue
  locale: string
  organizationId: string | undefined
}

export const convertBookkeepingTagDbValueToNavItemValue = async ({
  dbValue,
  locale,
  organizationId,
}: ConvertBookkeepingTagDbValueToNavItemValueProps): Promise<BookkeepingTagNavItemValue | undefined> => {
  try {
    const id = dbValue.tagId

    if (!id) {
      return undefined
    }

    const queryParams = {
      locale,
      categoryIds: [id],
      organizationId,
    }

    const tag = await fetchBookkeepingCategories(queryParams)

    if (!tag) {
      return undefined
    }

    const categoryData = tag.categories[0]

    let response: BookkeepingTag | undefined

    if (isBookkeepingTagCategory(categoryData)) {
      response = categoryData.question.answers.find((response) => {
        const { name, accountId } = response

        /* Legacy option works only matching name to name, string = string 
        => it did not apply your previous selected value if you changed the app language */
        if (isLegacyBookkeepingTag(dbValue.answer)) {
          return name === dbValue.answer?.option
        } else {
          /* New pattern matches by account id */
          return name === dbValue.answer?.name || accountId === dbValue.answer?.accountId
        }
      })
    } else {
      response = categoryData
    }

    return {
      tag: categoryData,
      response,
    }
  } catch {
    notify({ id: 'tag-fetch', message: `Could not fetch tag with id="${dbValue.tagId}"`, variant: 'error' })
    return undefined
  }
}
